import { makeStyles } from "@material-ui/core";
import { RemittanceLinkedToTransactionReconciledActivity } from "api/activity";
import { asCurrency, asDate, asTimelessDate, CollapsableSection, Column, Columns, FormInput, isEmbeddedApp, Link, PopoverValue } from "lqx-react";
import * as React from "react";
import { RemittanceDocumentLink } from "./remittanceDocumentLink";

export const RemittanceLinkedToTransactionReconciledDetails = ({data, currency} : {
    data : RemittanceLinkedToTransactionReconciledActivity,
    currency: string
}) => {
    const classes = useTextStyles();
    
    return (
        <>
        <CollapsableSection title="Transaction Details:">
            <Columns>
                <Column>
                    <FormInput label="Transaction Amount" value={asCurrency(data.transactionDetails.amount, currency)} />
                    <FormInput label="Value Date" value={asTimelessDate(data.transactionDetails.valueDate)} />
                    <Link href={`/inmatch/bank-transactions/details/${data.transactionDetails.transactionId}`}>Link to Transaction</Link>
                </Column>
                <Column>
                    <FormInput label="Statement Date" value={asTimelessDate(data.transactionDetails.statementDate)} />
                    <FormInput label="BAI Code" value={data.transactionDetails.baiCode} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Cash Application Details:">
            <Columns>
                <Column>
                    <FormInput label="Amount Remaining" value={asCurrency(data.reconciliationDetails.remainingAmount, currency)} />
                    <FormInput label="FX Gain/Loss" value={asCurrency(data.reconciliationDetails.fxGainLoss, currency)} />
                    <FormInput label="Write Off(Invoices)" value={asCurrency(data.reconciliationDetails.writeOff, currency)} />
                </Column>
                <Column>
                    <FormInput label="Total Amount Applied" value={asCurrency(data.reconciliationDetails.totalAmountApplied, currency)} />
                    <FormInput label="Processing Fee" value={asCurrency(data.reconciliationDetails.processingFee, currency)} />
                    <FormInput label="Discount(Invoices)" value={asCurrency(data.reconciliationDetails.discount, currency)} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Invoices:">
            <Columns>
                <Column>
                    <FormInput label="Total amount applied against Invoices" value={data.invoices.reduce((acc: number, inv) => acc + inv.amount, 0 )} />
                </Column>
                <Column>
                <label className={ classes.root }>
                    <span className={ classes.label }>
                        Number of Invoices
                    </span>
                    <div className={ classes.invoiceNumberValue }>
                        <PopoverValue anchorAlign="left" transformAlign="center" withCloseIcon={false} label={ data.invoices.length }>
                            {data.invoices.length ?
                            <>
                                {data.invoices.map(inv =>
                                    <div key={inv.cid}>
                                        <Link disabled={ isEmbeddedApp() } href={`/invoices/details/${inv.invoiceId}`}>
                                            {inv.invoiceNumber}
                                        </Link>
                                    </div>
                                )}
                            </> : undefined }
                        </PopoverValue>
                    </div>
                    </label>
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Linked Remittance Advice:">
            <Columns>
                <Column>
                    <FormInput label="Remittance Amount" value={asCurrency(data.remittanceAdviceDetails.amount, currency)} />
                </Column>
                <Column>
                    <RemittanceDocumentLink remittanceDocument={data.remittanceAdviceDetails.document} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Customer Details">
            <Columns>
                <Column>
                    <FormInput label="Customer Name" value={data.relationshipDetails.customerName} />
                </Column>
                <Column>
                    <FormInput label="Customer ID" value={data.relationshipDetails.customerId} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Supplier Details:">
            <Columns>
                <Column>
                    <FormInput label="Legal Entity Name" value={data.relationshipDetails.supplierLegalEntityName} />
                </Column>
                <Column>
                    <FormInput label="Company Code" value={data.relationshipDetails.supplierCompanyCode} />
                </Column>   
            </Columns>
        </CollapsableSection>
        </>
    );
}

const useTextStyles = makeStyles({
    root : {
        display: 'flex',
        flexDirection: 'row',
        color: '#767D84',
        fontFamily: 'Montserrat',
        fontSize: 12,
        fontWeight: 500,

        '&:focus-within' : {
            color: '#1084D3',
            fontWeight: 600,
        }
    },

    label: {
        flex: 2,
        alignSelf: 'center',
    },

    invoiceNumberValue : {
        flexDirection: 'column',
        flex : 3,
        display: 'inline-flex',
    },
});
